import React from 'react';
import Video from 'react-responsive-video'

export default function VideoComponent() {
    return (
        <Video height="720px" maxHeight="90vh" width="358px" maxWidth="90vw" controls="controls" mp4={`https://drive.google.com/uc?export=download&id=1k6350ydtsgC60W7z_uGqH8ty9zaPTP78`} />
    )
}
